<template>
  <div class="places-form-notes">
    <template v-if="place">
      <p class="page-subtitle">Note</p>

      <div class="form-group row">
        <!-- <label class="col-md-2 col-sm-4 col-12 col-form-label py-2">Note</label> -->
        <div class="col-12">
          <inline-editor
            :disabled="disabled"
            inputClasses="text-left borderless p-0 w-100"
            :value="place.notes"
            class="ml-auto my-auto"
            placeholder="Inserisci le note..."
            :textArea="true"
            :dataKeys="['notes']"
            @change="onDataUpdated"
          />
        </div>
      </div>
      <template v-if="place.acceptNotes && canSeeAcceptNotes">
        <p class="page-subtitle pt-2">Note di accettazione</p>
        <p style="white-space: pre-wrap">{{ place.acceptNotes }}</p>
      </template>
      <template v-if="place.installationNotes">
        <p class="page-subtitle pt-2">Note di installazione</p>
        <p style="white-space: pre-wrap">{{ place.installationNotes }}</p>
      </template>
    </template>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import InlineEditor from "components/InlineEditor.vue";
import { Place, User } from "models";
import { Getter } from "vuex-class";

@Component({ components: { InlineEditor } })
export default class PlaceData extends Vue {
  @Prop({ required: true })
  place: Place;

  @Getter currentUser?: User;

  @Prop({ default: false }) disabled?: boolean;

  onDataUpdated(data) {
    this.$emit("updated", data);
  }

  get canSeeAcceptNotes() {
    return (
      this.currentUser.isAdmin ||
      this.currentUser.isManager ||
      this.currentUser.isExecutive ||
      (this.currentUser.isAgent && this.currentUser == this.place.agent)
    );
  }
}
</script>

<style lang="scss">
.places-form-notes {
  .borderless {
    min-height: 300px;
    resize: none;
  }
}
</style>
